module.exports = __webpack_public_path__ + "img/calc.286840bb.png";